import '../styles/footer.css'
import { NavLink } from 'react-router-dom';
import logo from '../imgs/logo_1.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faGithub,faGooglePay } from '@fortawesome/free-brands-svg-icons';


export default function Downpage() {
   
    return(


        <footer className="footer-distributed">

			<div className="footer-left">

				<h3><span><img src={logo} alt="logo" width="100" height="100" style={{ borderRadius: '50%' }}/></span></h3>

				<p class="footer-links">
				
					<NavLink to="/">Home</NavLink>
					<NavLink to="/contact">Contact</NavLink>
					<NavLink to="/privacypolicy">Privacy policy</NavLink>

					
				</p>

				<p className="footer-company-name">EosRmg © {new Date().getFullYear()}</p>

				<div class="footer-icons">

				
				<a className='googlePlay' href='https://play.google.com/store/apps/dev?id=6256207236238699098'><FontAwesomeIcon icon={faGooglePay} /></a>
				<a className='tiktok' href='https://www.tiktok.com/@eosrmg'><FontAwesomeIcon icon={faTiktok} /></a>
                <a className='instagram' href='https://www.instagram.com/eosrmg_developer/'><FontAwesomeIcon icon={faInstagram} /></a>
                <a className='github' href='https://github.com/eosrmg'><FontAwesomeIcon icon={faGithub} /></a>


				</div>

			</div>

			<div className="footer-right">

				<p>Contact Us</p>

				<form action="https://formsubmit.co/biancaappsdev@gmail.com" method="post">
				    <input type="text" name="name"  placeholder="Full Name" required/>
					<input type="email" name="email" placeholder="Email" required/>
					<textarea name="message" placeholder="Message" required></textarea>
					<button className="Send" type="submit">Send</button>

				</form>

			</div>

		</footer>

          
           
         



    );
}